<div class="privacy_bg">
    <div class="inner_container">
        <div class="privacy_wrapper" *ngIf="lang == 'en'">
            <h3>We will handle the personal information we collect appropriately in accordance with "Privacy Policy" (<a href="https://www.manpowergroup.jp/english/info/privacypolicy.html" target="_blank">https://www.manpowergroup.jp/english/info/privacypolicy.html</a>).

</h3>
            <ol>
                <li>
                    <h6>Purpose of use of personal information</h6>
                    Personal information will be used to provide attendance management and payroll calculation services, billing services, support for the services provided, system maintenance and troubleshooting, employment management, creating statistical data, and other similar services.
                </li>
                
                <li>
                    <h6>Management of personal information</h6>
                    Personal information will only be used for the purposes described in the preceding paragraph, and will be handled appropriately to prevent unauthorized access, loss, destruction, falsification, leakage, etc. in accordance with our company's personal information protection policy (including other company regulations and related laws and regulations).
                    <ol>
                        <li>We conduct regular self-inspections of the handling of personal information, as well as audits by other departments and external parties.</li>
                        <li>Matters related to confidentiality of personal information are included in the work rules. Upon joining the company, employees pledge to maintain confidentiality.</li>
                        <li>We provide regular training to all employees on matters related to the handling of personal information.</li>
                        <li>In areas where personal information is handled, we manage the entry and exit of employees and restrict the equipment they bring in, as well as implement measures to prevent inappropriate use of personal information by employees who do not have entry and exit permissions.</li>
                        <li>We implement measures to prevent theft or loss of equipment, electronic media, documents, etc. that handle personal information.</li>
                        <li>We implement access control to limit the scope of personnel and personal information databases handled.</li>
                        <li>We have introduced a system to protect information systems that handle personal information from unauthorized access or malicious software from outside.</li>
                        <li>We implement safety management measures while understanding the systems related to the protection of personal information in the United States of America where we store personal information.</li>
                    </ol>
                </li>
                <li>
                    <h6>Provision of personal information to third parties</h6>
                    Personal information will not be provided to third parties without the consent of the individual, except in the following cases:
                    <ol>
                        <li>When necessary information has been clearly stated or notified to the individual in advance and consent has been obtained when required by law</li>
                        <li>When required by law</li>
                        <li>When it is necessary to protect a person's life, body, or property, and it is difficult to obtain the individual's consent.</li>
                        <li>When it is particularly necessary for the improvement of public health or the promotion of healthy child development, and it is difficult to obtain the consent of the individual.</li>
                        <li>When it is necessary to cooperate with a national government agency, local government, or a person commissioned by them in carrying out duties prescribed by law, and obtaining the individual's consent is likely to impede the performance of said duties.</li>
                    </ol>
                </li>
                <li>
                    <h6>Entrustment of personal information</h6>
                    We may entrust personal information to companies that meet our standards for personal information protection within the scope of the purposes of use set out in 1.
                </li>
                <li>
                    <h6>Voluntary provision of personal information</h6>
                    Providing personal information to our company is voluntary, but if you do not provide sufficient personal information, we may not be able to achieve the purpose of use set forth in 1.
                </li>
                <li>
                    <h6>Acquisition of personal information in a way that cannot be easily recognized by the individual</h6>
                    This website uses cookies to provide better service. Cookies are a mechanism that stores browsing history, input information, etc. as files on your computer when you use a web page.<br>
                    Cookies are personal information, but they do not contain any information that can identify an individual. In addition, we will not identify an individual by linking the acquired cookie information with personal information, nor will we provide cookies to third parties.
                </li>
                <li>
                    <h6>Transfer of personal information overseas</h6>
                    <ol>
                        <li>
                            <h6>Entrustment of Personal Information to the Parent Company (USA)</h6>
                            We entrust personal information to our parent company, ManpowerGroup Inc., a third party located overseas that meets our company's standards for personal information protection, within the scope of the purposes of use set forth in 1. The parent company's servers are located in the United States.
                        </li>
                        <li>
                            <h6>Whether or not there is a system for protecting personal information in the foreign country to which the information is being transferred</h6>
                            In the United States, which is the destination country, there is no comprehensive personal information protection law; however, there are laws that apply to specific sectors.<br>
                            Reference: <a href="https://www.ppc.go.jp/files/pdf/USA_report.pdf" target="_blank">https://www.ppc.go.jp/files/pdf/USA_report.pdf</a> (Personal Information Protection Committee)
                        </li>
                        <li>
                            <h6>The existence of information that can serve as an indicator of the system</h6>
                            We implement safety management measures after understanding the personal information protection systems in the United States, where personal information is stored. The United States is also a participating country in the APEC CBPR (Cross-Border Privacy Rules) system.
                        </li>
                        <li>
                            <h6>Method of establishing a system for providing personal information to such third parties</h6>
                            We provide personal information under a contract between our company and the third party to whom we outsource (our parent company, ManpowerGroup Inc.).
                        </li>
                        <li>
                            <h6>Measures to protect personal information taken by the third party</h6>
                            The outsourcing contract stipulates that the third party will handle personal data within the scope necessary to achieve the specified purposes of use, will not change the purposes of use without our prior consent, will take necessary and appropriate safety control measures, and will appoint a manager responsible for handling personal information.
                        </li>
                        <li>
                            <h6>Frequency and method of confirmation</h6>
                            We may request reports on the measures implemented by the third party, and will periodically confirm the measures by receiving written reports.
                        </li>
                        <li>
                            <h6>Opting out of providing personal information</h6>
                           If the third party handles personal information in violation of the outsourcing contract, including the measures described in (2) above, and even if we request that the third party promptly correct the handling in accordance with the outsourcing contract, if the correction is not made within a reasonable period of time and we determine that it is difficult to ensure the continued implementation of appropriate measures, we will cease providing personal information to the third party.
                        </li>
                    </ol>
                </li>
                <li>
                    <h6>Disclosure of personal information subject to disclosure</h6>
                    With regard to personal data held by our company that is subject to disclosure, you may request notification of the purpose of use, correction, addition or deletion of the content, or suspension of use or deletion, or suspension of provision to third parties, and you may also request correction, addition or deletion of personal information as a result of disclosure (hereinafter referred to as a "request for disclosure, etc."). In addition, when we receive a request for disclosure, etc., we will inform the individual about the procedure for requesting disclosure, etc., and will respond appropriately and promptly within a reasonable scope.<br>
                    However, we cannot respond if it violates the law.<br>
                    For inquiries, please contact the following complaints desk:<br>
                    *If you would like to have your information disclosed electronically, please let us know. As a general rule, we will comply with your request.
                </li>
                <li>
                    <h6>Inquiries regarding personal information</h6>
                    For requests for disclosure of personal information or complaints, please contact the following:<br>
                    *If you would like to have your information disclosed electronically, please let us know. In principle, we will comply with your request.
                </li>
                <li>
                    <h6>Inquiries regarding personal information</h6>
                    For requests for disclosure of personal information or complaints, please contact the following:<br>
                    Complaints consultation desk: TEL 0120-850-074<br>
                    *Monday to Friday (excluding Saturdays, Sundays, public holidays, and the New Year holidays) 10:00 to 18:00
                </li>
                
            </ol>
            <p class="text_right">
                   ManpowerGroup Co., Ltd.<br>
                   Personal information protection manager<br>
                   Executive Officer, Head of Legal & Compliance Department
            </p>
            <div class="condition_text">
                <p>Consent to the handling of personal information as described above.</p>
                <p>
                    <label for="">
                        <input id="" class="hs-input" type="checkbox" name="" value="true" #acceptTerms>Agree
                    </label>
                </p>
                <div class="actio_button_area">
                    <button class="btn butn btn-sm" (click)="giveConsent(acceptTerms.checked)">Submit</button>
                    <button class="btn butn cancel_entry btn-sm" id="consent_close" (click)="cancelConsent()">Cancel</button>
                </div>
            </div>
        </div>
        <div class="privacy_wrapper" *ngIf="lang == 'jp'">
            <h3>当社は、取得した個人情報を、「個人情報保護方針」（<a href="https://www.manpowergroup.jp/security-policy/security/" target="_blank">https://www.manpowergroup.jp/security-policy/security/</a> の内容に従い、適切に取扱います。</h3>
            <ol>
                <li>
                    <h6>個人情報の利用目的</h6>
                    個人情報は、勤怠管理・給与計算サービスのご提供、ご請求サービスのご提供、ご提供サービスに関するサポートのご提供、システムの維持・不具合対応、雇用管理、統計データの作成、及びこれらに準ずる業務の遂行のために利用します。
                </li>
                
                <li>
                    <h6>個人情報の管理</h6>
                    個人情報は、前項記載の目的にのみ利用し、当社の個人情報保護方針（他当社規程及び関連する法令等を含む）に準拠し、不正アクセス・紛失・破壊・改ざん・漏洩等がないように適切に取扱います。
                    <ol>
                        <li>個人情報の取扱状況について、定期的に自己点検を実施するとともに、他部署や外部の者による監査を実施しています。</li>
                        <li>個人情報についての機密保持に関する事項を就業規則に記載しています。 入社時において、機密保持に関する誓約書に誓約しています。</li>
                        <li>個人情報の取扱いに関する留意事項について、全従業者に対し定期的な研修を実施しています。</li>
                        <li>個人情報を取扱う区域において、従業者の入退出管理及び持ち込む機器等の制限を行うとともに、入退出権限を有しない従業者による個人情報の不適切な利用を防止する措置を実施しています。</li>
                        <li>個人情報を取扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するための措置を実施しています。</li>
                        <li>アクセス制御を実施して、担当者及び取扱う個人情報データベース等の範囲を限定しています。</li>
                        <li>個人情報を取扱う情報システムを外部からの不正アクセス又は不正ソフトウエアから保護する仕組みを導入しています。</li>
                        <li>個人情報を保管しているアメリカ合衆国における個人情報保護に関する制度を把握した上で安全管理措置を実施しています。</li>
                    </ol>
                </li>
                <li>
                    <h6>個人情報の第三者提供</h6>
                    個人情報は、以下に該当する場合を除き、ご本人の同意なく第三者に提供することはありません。
                    <ol>
                        <li>予め、ご本人に必要事項を明示又は通知し同意を得ているとき</li>
                        <li>法令に基づく場合</li>
                        <li>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                        <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                        <li>国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
                    </ol>
                </li>
                <li>
                    <h6>個人情報の委託</h6>
                    当社で定める個人情報保護の基準を満たした企業に、1の利用目的の範囲内において個人情報を委託する場合があります。
                </li>
                <li>
                    <h6>個人情報提供の任意性</h6>
                    個人情報の当社への提供は任意によるものですが、十分な個人情報を提供いただけない場合には、1の利用目的を達成できないことがあります。
                </li>
                <li>
                    <h6>本人が容易に認識できない方法による個人情報の取得</h6>
                    当サイトでは、より良いサービスをご提供するためにCookieを取得しています。Cookieとはお客様がウェブページを利用した際に、閲覧履歴や入力内容等を、お客様のコンピュータにファイルとして保存しておく仕組みです。<br>
                    Cookieは個人関連情報ですが、Cookie自体には個人を特定できる情報は含みません。また、取得したCookie情報を個人情報と紐づけることで個人を特定すること、又はCookieを第三者へ提供を行うことはありません。
                </li>
                <li>
                    <h6>個人情報の海外移転</h6>
                    <ol>
                        <li>
                            <h6>親会社（アメリカ合衆国）への個人情報の委託</h6>
                            当社は、当社で定める個人情報保護の基準を満たした外国にある第三者である親会社のManpowerGroup Inc.に対し、1の利用目的の範囲内において個人情報を委託します。なお、親会社のサーバーはアメリカ合衆国に置かれています。
                        </li>
                        <li>
                            <h6>移転先の外国における個人情報の保護に関する制度の有無</h6>
                            移転先の外国であるアメリカ合衆国において、包括的な法令は存在しませんが、個別の分野に適用される法令が存在します。<br>
                            参照：<a href="https://www.ppc.go.jp/files/pdf/USA_report.pdf" target="_blank">https://www.ppc.go.jp/files/pdf/USA_report.pdf</a>（個人情報保護委員会）
                        </li>
                        <li>
                            <h6>当該制度についての指標となり得る情報の存在</h6>
                            個人情報を保管しているアメリカ合衆国における個人情報保護に関する制度を把握した上で安全管理措置を実施しています。なおアメリカ合衆国は、APECのCBPRシステムの加盟国に該当します。
                        </li>
                        <li>
                            <h6>当該第三者に対する個人情報の提供体制整備の方法：</h6>
                            当社と委託先である当該第三者（親会社のManpowerGroup Inc.）との間において、委託契約を締結して個人情報を提供しています。
                        </li>
                        <li>
                            <h6>当該第三者が講ずる個人情報保護のための措置</h6>
                            委託契約において、当該第三者は、特定した利用目的の達成に必要な範囲内で個人データを取り扱う旨、その利用目的を当社の事前の承諾なく変更しない旨、必要かつ適切な安全管理措置を講ずる旨、個人情報の取扱いに関する管理責任者を定める旨等を定めています。
                        </li>
                        <li>
                            <h6>確認の頻度及び方法</h6>
                            当社は、当該第三者が実施している措置に関して、報告を求めることができるものとし、定期的に、書面による報告を受ける形で確認いたします。
                        </li>
                        <li>
                            <h6>個人情報の提供の停止:</h6>
                            当社は、当該第三者が上記（２）の措置を含む委託契約に反する個人情報の取扱いをしている場合であって、委託契約に基づき、速やかに当該取扱いを是正するように要請しても、合理的期間内にこれが是正されず、相当措置の継続的な実施の確保が困難であると判断する場合は、当該第三者への個人情報の提供を停止いたします。
                        </li>
                    </ol>
                </li>
                <li>
                    <h6>保有個人データの開示・訂正・削除の求めについて​</h6>
                    当社が保有する保有個人データについて、利用目的の通知・開示又は利用の停止・消去又は第三者への提供の停止を請求すること及び開示の結果、個人情報の訂正・追加・削除を請求すること（以下、「開示等の請求」といいます。）ができます。また、当社では、開示等の請求を受け付けた場合は、手続き等について本人にお知らせし、合理的な範囲で適切かつ迅速に対応させていただきます。お問い合わせの窓口は下記の苦情・相談窓口担当が対応いたします。​ただし法律に抵触する場合においては、対応できません。<br>
                    なお、お問い合わせの窓口は下記の苦情相談窓口が対応します。<br>
                    ※電磁的手続きによる開示等をご希望の方は、その旨お申し出ください。原則としてご希望に沿って対応いたします。
                </li>
                <li>
                    <h6>個人情報に関するお問い合わせ</h6>
                    個人情報に関する開示等の請求及び苦情相談に関しては、下記の連絡先へお問い合わせください。<br>
                    ※電磁的手続きによる開示等をご希望の方は、その旨お申し出ください。原則としてご希望に沿って対応いたします。
                </li>
                <li>
                    <h6>個人情報に関するお問い合わせ</h6>
                    個人情報に関する開示等の請求及び苦情相談に関しては、下記の連絡先へお問い合わせください。<br>
                    苦情相談窓口担当：TEL0120-850-074<br>
                    ※月曜～金曜（土日祝日、年末年始は除く）10時～18時
                </li>
                
            </ol>
            <p class="text_right">
                   マンパワーグループ株式会社<br>
                   個人情報保護管理者<br>
                   執行役員 リーガル＆コンプライアンス部長
            </p>
            <div class="condition_text">
                <p> 上記、個人情報の取り扱いについて</p>
                <p>
                    <label for="">
                        <input id="" class="hs-input" type="checkbox" name="" value="true" #acceptTerms>同意する
                    </label>
                </p>
                <div class="actio_button_area">
                    <button class="btn butn btn-sm" (click)="giveConsent(acceptTerms.checked)">送信</button>
                    <button class="btn butn cancel_entry btn-sm" id="consent_close" (click)="cancelConsent()">キャンセル</button>
                </div>
            </div>
        </div>
    </div>
</div>
